import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

const fetchOM05 = async () => {
  const response = await axios.get(`${WiMuleSQL}/api/BWOS/GetOM05OpenPicks`);

  return response.data.data;
};

export const useOM05OpenPicks = (enabled = true) =>
  useQuery({
    queryKey: ["OM05"],
    queryFn: () => fetchOM05(),
    enabled,
    staleTime: 60 * 1000, // 1 min if focused
    gcTime: 5 * 60 * 1000, // cache for 5 min if unfocused
    refetchInterval: 60 * 1000, // ← auto-update every minute
  });
